// angular
import { ChangeDetectionStrategy, Component } from '@angular/core';
// libs
import { DynamicFormInputBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-dynamic-form-input',
  templateUrl: './dynamic-form-input.component.html',
  styleUrls: ['./dynamic-form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicFormInputComponent extends DynamicFormInputBaseComponent {}
